import axios from "axios";
import { v4 as uuidv4 } from "uuid";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const CONSENT_KEY = "rr_analytics_consent";
const SESSION_KEY = "rr_analytics_session_id";

export const getConsent = () => localStorage.getItem(CONSENT_KEY);

export const setConsent = (value) => {
  localStorage.setItem(CONSENT_KEY, value);
};

const getSessionId = () => {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = uuidv4();
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

// Self-hosted, privacy-first: no tracking fires until the visitor accepts the
// cookie-consent banner, no third party ever receives this data.
export const trackEvent = (eventType, { path, section, ...metadata } = {}) => {
  if (getConsent() !== "accepted") return;
  axios
    .post(`${API}/analytics/event`, {
      session_id: getSessionId(),
      event_type: eventType,
      path: path || window.location.pathname,
      section: section || null,
      metadata,
    })
    .catch(() => {});
};

export const trackPageview = (path) => trackEvent("pageview", { path });
export const trackSectionView = (section) => trackEvent("section_view", { section });
